<app-dialog-header [title]="(isEdit ? 'Edit' : 'Add') + ' Time Block'" (closeClicked)="onClose()">
</app-dialog-header>

<div mat-dialog-content>
    <form [formGroup]="entryForm">
        <div class="form-row">
            <mat-form-field appearance="fill">
                <mat-label>Day</mat-label>
                <mat-select formControlName="offsetDay">
                    @for (day of availableDays; track day) {
                    <mat-option [value]="day.value">
                        {{day.label}}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-row time-controls">
            <mat-form-field appearance="fill">
                <mat-label>Start Hour</mat-label>
                <input matInput type="number" min="0" max="23" formControlName="startOffsetHour" aria-label="Start hour"
                    placeholder="Hour (0-23)">
                @if (entryForm.get('startOffsetHour').hasError('min') ||
                entryForm.get('startOffsetHour').hasError('max')) {
                <mat-error>
                    Must be between 0-23
                </mat-error>
                }
            </mat-form-field>

            <span class="time-separator">:</span>

            <mat-form-field appearance="fill">
                <mat-label>Start Minute</mat-label>
                <input matInput type="number" min="0" max="59" formControlName="startOffsetMinute"
                    aria-label="Start minute" placeholder="Minute (0-59)">
                @if (entryForm.get('startOffsetMinute').hasError('min') ||
                entryForm.get('startOffsetMinute').hasError('max')) {
                <mat-error>
                    Must be between 0-59
                </mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Hidden field to store actual duration in minutes -->
        <input type="hidden" formControlName="duration">

        <div class="form-row">
            <label>Duration</label>
            <div class="time-controls">
                <mat-form-field appearance="fill">
                    <mat-label>Hours</mat-label>
                    <input matInput type="number" min="0" max="24" formControlName="durationHours"
                        aria-label="Duration hours" placeholder="Hours (0-24)">
                    @if (entryForm.get('durationHours').hasError('min') ||
                    entryForm.get('durationHours').hasError('max')) {
                    <mat-error>
                        Must be between 0-24
                    </mat-error>
                    }
                </mat-form-field>

                <span class="time-separator">:</span>

                <mat-form-field appearance="fill">
                    <mat-label>Minutes</mat-label>
                    <input matInput type="number" min="0" max="59" formControlName="durationMinutes"
                        aria-label="Duration minutes" placeholder="Minutes (0-59)">
                    @if (entryForm.get('durationMinutes').hasError('min') ||
                    entryForm.get('durationMinutes').hasError('max')) {
                    <mat-error>
                        Must be between 0-59
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            @if (entryForm.get('duration').hasError('min')) {
            <mat-error>
                Duration must be at least 5 minutes
            </mat-error>
            }
            @if (entryForm.get('duration').hasError('max')) {
            <mat-error>
                Duration cannot exceed 24 hours (1440 minutes)
            </mat-error>
            }
        </div>
    </form>
</div>

<div mat-dialog-actions align="end">
    @if (isEdit) {
    <button mat-raised-button color="warn" (click)="deleteEntry()">Delete</button>
    }
    <button mat-raised-button color="primary" [disabled]="!entryForm.valid" (click)="saveEntry()">Save</button>
</div>